import { getUniversalHelpers } from "../../helpers";

export async function team__client__setTeamPhoto(p: { teamId: string; teamPhotoUri: string | null }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  await h.Team.update({ id: p.teamId, doc: { teamPhotoUri: p.teamPhotoUri ?? h._MagicDeleteValue } });
}

// i18n certified - complete
